import { render, staticRenderFns } from "./MatchmakingWidget.vue?vue&type=template&id=4cb264e2&scoped=true&"
import script from "./MatchmakingWidget.vue?vue&type=script&lang=js&"
export * from "./MatchmakingWidget.vue?vue&type=script&lang=js&"
import style0 from "./MatchmakingWidget.vue?vue&type=style&index=0&id=4cb264e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb264e2",
  null
  
)

component.options.__file = "MatchmakingWidget.vue"
export default component.exports